import { Icon, Paper, Typography } from '@material-ui/core'
import { DocumentContext } from 'context'
import React from 'react'
import CountUp from 'react-countup'
import { useHistory } from 'react-router-dom'

interface Props {
  countPath?: string
  handleNotifyError: () => void
  handleLoadingFilter: (state: boolean) => void
  handleClearFilters: () => Promise<void>
}

const fullScreenWidth = window.screen.width
const fullScreenHeight = window.screen.height

const CountDocumentsRetenciones = React.memo((props: Props) => {
  const { countPath, handleNotifyError, handleLoadingFilter, handleClearFilters } = props
  const {
    count,
    conditions,
    documentsModel,
    getDocumentsByFiltersRetentions,
    setFilters,
    documentFilters: filters,
  } = React.useContext(DocumentContext)
  const { handleChangePage } = documentsModel
  const {
    completed,
    rejected,
    pending,
    total,
    entered,
    error,
    unsend,
    onhold,
    anuled,
    processes,
    acounted,
    value,
  } = count
  const [recount, setRecount] = React.useState<number>(0)
  const history = useHistory()

  React.useEffect(() => {
    setRecount(Math.random())
  }, [])

  const [showIcons, setShowIcons] = React.useState(
    window.innerWidth / window.devicePixelRatio > 1024
  )

  React.useEffect(() => {
    const handleResize = () => {
      setShowIcons(window.innerWidth / window.devicePixelRatio > 1024)
    }

    window.addEventListener('resize', handleResize)
    window.addEventListener('wheel', handleResize) // Detectar cambios en zoom
    window.addEventListener('mousemove', handleResize) // Opcional, para algunos navegadores

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('wheel', handleResize)
      window.removeEventListener('mousemove', handleResize)
    }
  }, [])

  const handleFilter = async (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    conditionName: string
  ) => {
    e.preventDefault()
    try {
      const condiFind = conditions.find((c) => c.name === conditionName)
      if (condiFind) {
        const newFilters = { ...filters, conditions: [condiFind] }
        setFilters(newFilters)
        handleLoadingFilter(true)
        await getDocumentsByFiltersRetentions(undefined, undefined, newFilters)
      } else {
        setFilters({ ...filters, conditions: [] })
      }
      handleChangePage(undefined, 0)
      handleLoadingFilter(false)
    } catch (error) {
      handleNotifyError()
    } finally {
      handleLoadingFilter(false)
    }
  }

  return (
    <div className="flex items-center w-full pb-4 justify-between">
      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#a4a4a4',
          flex: 1,
        }}
        elevation={0}
      >
        <div className="ml-2" style={{ textAlign: 'center' }}>
          <div>
            <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
              {value ? value : '$ 0.00'}
            </Typography>
          </div>

          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Monto'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#8b8b8b',
          flex: 1,
          maxWidth: '50%',
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Contabilizado')
        }}
      >
        {showIcons && ( // Conditionally render the icon
          <div className="glass-md flex items-center justify-center p-2">
            <Icon className="opacity-50">flag</Icon>
          </div>
        )}
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={acounted}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Contabilizadas'}
          </Typography>
        </div>
      </Paper>

      {/* <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: "#FFD54F",
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, "En Espera");
        }}
      >
        {showIcons && (
          <div className="glass-md flex items-center justify-center p-2">
            <Icon className="opacity-50">close</Icon>
          </div>
        )}
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={onhold}>
            {({ countUpRef }) => (
              <div>
                <Typography
                
                  variant="h5"
                  style={{ fontWeight: 900, color: '#393636' }}
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {"En Espera"}
          </Typography>
        </div>
      </Paper> */}

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#656565',
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Pendiente')
        }}
      >
        {showIcons && (
          <div className="glass-md flex items-center justify-center p-2">
            <Icon className="opacity-50">arrow_upward</Icon>
          </div>
        )}
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={pending}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Pendientes'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#F9A825',
          flex: 1,
          maxWidth: '50%',
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'En Proceso')
        }}
      >
        {showIcons && (
          <div className="glass-md flex items-center justify-center p-2">
            <Icon className="opacity-50">flag</Icon>
          </div>
        )}
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={processes}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Por Contabilizar'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex flex-grow mr-2 items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#FFA000',
          flex: 1,
        }}
        elevation={0}
        onClick={async (e) => {
          await handleFilter(e, 'Rechazado QF')
        }}
      >
        {showIcons && (
          <div className="glass-md flex items-center justify-center p-2">
            <Icon className="opacity-50">timelapse</Icon>
          </div>
        )}
        <div className="ml-4">
          <CountUp start={recount} duration={1} end={rejected}>
            {({ countUpRef }) => (
              <div>
                <Typography variant="h5" style={{ fontWeight: 900, color: '#393636' }}>
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Rechazados'}
          </Typography>
        </div>
      </Paper>

      <Paper
        className="px-4 py-3 flex items-center justify-start relative overflow-hidden cursor-pointer"
        style={{
          backgroundColor: '#FFA000',
        }}
        elevation={0}
        onClick={async () => {
          await handleClearFilters()
        }}
      >
        <div className="mx-4">
          <CountUp start={recount} duration={1} end={total}>
            {({ countUpRef }) => (
              <div>
                <Typography
                  variant="h5"
                  style={{ fontWeight: 900, color: '#393636' }}
                  align="center"
                >
                  <span ref={countUpRef} />
                </Typography>
              </div>
            )}
          </CountUp>
          <Typography
            className="opacity-75 font-bold"
            style={{ fontSize: showIcons ? '11px' : '8px' }}
          >
            {'Total'}
          </Typography>
        </div>
      </Paper>
    </div>
  )
})

export default CountDocumentsRetenciones
